import { ReactNode, createContext, useContext, useState } from "react"
import { PathCreatorRawValues } from "./state"

type PathCreatorContextValue = {
  initialValue?: PathCreatorRawValues
  setInitialValue: (value?: PathCreatorRawValues) => void
}

export const PathCreatorContext = createContext<PathCreatorContextValue>(
  {} as PathCreatorContextValue
)

export const usePathCreatorContext = () => useContext(PathCreatorContext)

type PathCreatorContextProps = {
  children: ReactNode
}

export const PathCreatorContextProvider = ({
  children
}: PathCreatorContextProps) => {
  const [initialValue, setInitialValue] = useState<PathCreatorRawValues>()

  return (
    <PathCreatorContext.Provider value={{ initialValue, setInitialValue }}>
      {children}
    </PathCreatorContext.Provider>
  )
}
